import { Icon } from "@nju/icons";
import { BlockText, Text } from "@nju/ui";

interface IOrderStatusProps {
  status: string;
}

export function OrderStatus({ status }: IOrderStatusProps) {
  return (
    <div className="flex items-center basis-full from-tablet:basis-1/2">
      <Icon
        className="mr-4 w-[24px] h-[24px] from-tablet:w-[32px] from-tablet:h-[32px]"
        name="check-circle"
        tone="accent"
      />
      <div className="flex-1">
        <Text
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
        >
          status
        </Text>
        <BlockText
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "l",
          }}
          weight="bold"
        >
          {status}
        </BlockText>
      </div>
    </div>
  );
}
